export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_Aboutus-610e8967a2ef7414fc770a49669eee28.jpg";